"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDropOffMessageEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const VehicleDropOffDto_1 = require("../vehicle-drop-offs/VehicleDropOffDto");
const VehicleDropOffEntity_1 = require("../vehicle-drop-offs/VehicleDropOffEntity");
const VehicleDropOffMessageDto_1 = require("./VehicleDropOffMessageDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class VehicleDropOffMessageEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, vehicleDropOffMessage) {
        super();
        this._requiredFieldsSetStatus = {
            vehicleDropOffId: false,
            messageType: false,
            text: false
        };
        this._dependencies = dependencies;
        if (vehicleDropOffMessage === undefined) {
            this._dto = new VehicleDropOffMessageDto_1.VehicleDropOffMessageDto();
        }
        else if (vehicleDropOffMessage instanceof VehicleDropOffMessageDto_1.VehicleDropOffMessageDto) {
            this._dto = new VehicleDropOffMessageDto_1.VehicleDropOffMessageDto(vehicleDropOffMessage);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (vehicleDropOffMessage instanceof VehicleDropOffMessageEntity) {
            this._dto = new VehicleDropOffMessageDto_1.VehicleDropOffMessageDto(vehicleDropOffMessage._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new VehicleDropOffMessageDto_1.VehicleDropOffMessageDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getVehicleDropOff() {
        if (this._dto.vehicleDropOffId === undefined) {
            return undefined;
        }
        if (this._dto.vehicleDropOff === undefined) {
            throw new Error("Cannot call getVehicleDropOff without " +
                "first loading the VehicleDropOff.");
        }
        if (!this._vehicleDropOffEntity && this._dto.vehicleDropOff) {
            this._vehicleDropOffEntity = new VehicleDropOffEntity_1.VehicleDropOffEntity(this._dependencies, this._dto.vehicleDropOff);
        }
        return this._vehicleDropOffEntity;
    }
    setVehicleDropOff(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof VehicleDropOffEntity_1.VehicleDropOffEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof VehicleDropOffDto_1.VehicleDropOffDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setVehicleDropOffId(untrustedId);
        if (this.hasError("vehicleDropOffId")) {
            return;
        }
        if (untrustedValue instanceof VehicleDropOffEntity_1.VehicleDropOffEntity) {
            this._vehicleDropOffEntity = untrustedValue;
        }
    }
    getVehicleDropOffId() {
        return this._dto.vehicleDropOffId;
    }
    setVehicleDropOffId(untrustedValue) {
        let _untrustedValue;
        this.clearError("vehicleDropOffId");
        this._requiredFieldsSetStatus.vehicleDropOffId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("vehicleDropOffId", "Vehicle Drop Off Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("vehicleDropOffId", "Vehicle Drop Off is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.vehicleDropOffId) {
            return;
        }
        this._dto.vehicleDropOffId = _untrustedValue;
        delete this._vehicleDropOffEntity;
        this._setIsDirty(true);
    }
    getMessageType() {
        return this._dto.messageType;
    }
    setMessageType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("messageType");
        this._requiredFieldsSetStatus.messageType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("messageType", "Message Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("messageType", `Message Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.messageType) {
            return;
        }
        this._dto.messageType = _untrustedValue;
        this._setIsDirty(true);
    }
    getText() {
        return this._dto.text;
    }
    setText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("text");
        this._requiredFieldsSetStatus.text = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("text", "Text is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("text", `Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.text) {
            return;
        }
        this._dto.text = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageFileName() {
        return this._dto.imageFileName;
    }
    setImageFileName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("imageFileName");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("imageFileName", "Image File Name is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("imageFileName", `Image File Name has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.imageFileName) {
            return;
        }
        this._dto.imageFileName = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageContentType() {
        return this._dto.imageContentType;
    }
    setImageContentType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("imageContentType");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("imageContentType", "Image Content Type is required."));
        }
        else {
            if (_untrustedValue.length > maxLength) {
                this.addError(new ValidationError_1.ValidationError("imageContentType", `Image Content Type has exceeded the maximum length (${maxLength} chr).`));
            }
        }
        if (!this.isNew && _untrustedValue === this._dto.imageContentType) {
            return;
        }
        this._dto.imageContentType = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageFileSize() {
        return this._dto.imageFileSize;
    }
    setImageFileSize(untrustedValue) {
        let _untrustedValue;
        this.clearError("imageFileSize");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 0 })) {
            this.addError(new ValidationError_1.ValidationError("imageFileSize", "Image File Size is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.imageFileSize) {
            return;
        }
        this._dto.imageFileSize = _untrustedValue;
        this._setIsDirty(true);
    }
    getImageUpdatedAt() {
        return this._dto.imageUpdatedAt;
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getFrom() {
        return this._dto.from;
    }
    setFrom(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("from");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("from", "From is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("from", `From has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.from) {
            return;
        }
        this._dto.from = _untrustedValue;
        this._setIsDirty(true);
    }
    getAttachmentFileName() {
        return this._dto.attachmentFileName;
    }
    setAttachmentFileName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("attachmentFileName");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("attachmentFileName", "Attachment File Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("attachmentFileName", `Attachment File Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.attachmentFileName) {
            return;
        }
        this._dto.attachmentFileName = _untrustedValue;
        this._setIsDirty(true);
    }
    getAttachmentContentType() {
        return this._dto.attachmentContentType;
    }
    setAttachmentContentType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("attachmentContentType");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("attachmentContentType", "Attachment Content Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("attachmentContentType", `Attachment Content Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.attachmentContentType) {
            return;
        }
        this._dto.attachmentContentType = _untrustedValue;
        this._setIsDirty(true);
    }
    getAttachmentFileSize() {
        return this._dto.attachmentFileSize;
    }
    setAttachmentFileSize(untrustedValue) {
        let _untrustedValue;
        this.clearError("attachmentFileSize");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 0 })) {
            this.addError(new ValidationError_1.ValidationError("attachmentFileSize", "Attachment File Size is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.attachmentFileSize) {
            return;
        }
        this._dto.attachmentFileSize = _untrustedValue;
        this._setIsDirty(true);
    }
    getAttachmentUpdatedAt() {
        return this._dto.attachmentUpdatedAt;
    }
    getPaymentInvoiceUrl() {
        return this._dto.paymentInvoiceUrl;
    }
    setPaymentInvoiceUrl(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("paymentInvoiceUrl");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("paymentInvoiceUrl", "Payment Invoice Url is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("paymentInvoiceUrl", `Payment Invoice Url has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.paymentInvoiceUrl) {
            return;
        }
        this._dto.paymentInvoiceUrl = _untrustedValue;
        this._setIsDirty(true);
    }
    getPaymentAmount() {
        return this._dto.paymentAmount;
    }
    setPaymentAmount(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("paymentAmount");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("paymentAmount", "Payment Amount is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("paymentAmount", `Payment Amount Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.paymentAmount) {
            return;
        }
        this._dto.paymentAmount = _untrustedValue;
        this._setIsDirty(true);
    }
    getPaymentRequestStatus() {
        return this._dto.paymentRequestStatus;
    }
    setPaymentRequestStatus(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("paymentRequestStatus");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("paymentRequestStatus", "Payment Request Status is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("paymentRequestStatus", `Payment Request Status has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.paymentRequestStatus) {
            return;
        }
        this._dto.paymentRequestStatus = _untrustedValue;
        this._setIsDirty(true);
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto =
                    yield this._dependencies.vehicleDropOffMessageDatastore
                        .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Vehicle Drop Off Message is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.vehicleDropOffMessageDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.vehicleDropOffMessageDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Vehicle Drop Off Message cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.vehicleDropOffMessageDatastore.removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.VehicleDropOffMessageEntity = VehicleDropOffMessageEntity;
//# sourceMappingURL=VehicleDropOffMessageEntity.js.map